import { type ComponentProps } from "react";

export default function CalendarIconV2(svgProps: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8086 7.23438C12.1322 7.23438 12.3945 6.97204 12.3945 6.64844C12.3945 6.32483 12.1322 6.0625 11.8086 6.0625C11.485 6.0625 11.2227 6.32483 11.2227 6.64844C11.2227 6.97204 11.485 7.23438 11.8086 7.23438Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M13.1562 1.67187H12.3945V1.08594C12.3945 0.762324 12.1322 0.5 11.8086 0.5C11.485 0.5 11.2227 0.762324 11.2227 1.08594V1.67187H8.55664V1.08594C8.55664 0.762324 8.29432 0.5 7.9707 0.5C7.64709 0.5 7.38476 0.762324 7.38476 1.08594V1.67187H4.74805V1.08594C4.74805 0.762324 4.48572 0.5 4.16211 0.5C3.8385 0.5 3.57617 0.762324 3.57617 1.08594V1.67187H2.84375C1.55141 1.67187 0.5 2.72328 0.5 4.01562V13.1562C0.5 14.4486 1.55141 15.5 2.84375 15.5H7.32617C7.64978 15.5 7.91211 15.2377 7.91211 14.9141C7.91211 14.5904 7.64978 14.3281 7.32617 14.3281H2.84375C2.19758 14.3281 1.67187 13.8024 1.67187 13.1562V4.01562C1.67187 3.36945 2.19758 2.84375 2.84375 2.84375H3.57617V3.42969C3.57617 3.7533 3.8385 4.01562 4.16211 4.01562C4.48572 4.01562 4.74805 3.7533 4.74805 3.42969V2.84375H7.38476V3.42969C7.38476 3.7533 7.64709 4.01562 7.9707 4.01562C8.29432 4.01562 8.55664 3.7533 8.55664 3.42969V2.84375H11.2227V3.42969C11.2227 3.7533 11.485 4.01562 11.8086 4.01562C12.1322 4.01562 12.3945 3.7533 12.3945 3.42969V2.84375H13.1562C13.8024 2.84375 14.3281 3.36945 14.3281 4.01562V7.35547C14.3281 7.67908 14.5904 7.94141 14.9141 7.94141C15.2377 7.94141 15.5 7.67908 15.5 7.35547V4.01562C15.5 2.72328 14.4486 1.67187 13.1562 1.67187Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M11.9551 8.40625C10.0004 8.40625 8.41016 9.99648 8.41016 11.9512C8.41016 13.9059 10.0004 15.4961 11.9551 15.4961C13.9098 15.4961 15.5 13.9059 15.5 11.9512C15.5 9.99648 13.9098 8.40625 11.9551 8.40625ZM11.9551 14.3242C10.6466 14.3242 9.58203 13.2597 9.58203 11.9512C9.58203 10.6427 10.6466 9.57813 11.9551 9.57813C13.2636 9.57813 14.3281 10.6427 14.3281 11.9512C14.3281 13.2597 13.2636 14.3242 11.9551 14.3242Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M12.8027 11.373H12.5391V10.7578C12.5391 10.4342 12.2767 10.1719 11.9531 10.1719C11.6295 10.1719 11.3672 10.4342 11.3672 10.7578V11.959C11.3672 12.2826 11.6295 12.5449 11.9531 12.5449H12.8027C13.1263 12.5449 13.3887 12.2826 13.3887 11.959C13.3887 11.6354 13.1263 11.373 12.8027 11.373Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M9.25781 7.23438C9.58142 7.23438 9.84375 6.97204 9.84375 6.64844C9.84375 6.32483 9.58142 6.0625 9.25781 6.0625C8.93421 6.0625 8.67188 6.32483 8.67188 6.64844C8.67188 6.97204 8.93421 7.23438 9.25781 7.23438Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M6.71094 9.78125C7.03454 9.78125 7.29688 9.51892 7.29688 9.19531C7.29688 8.87171 7.03454 8.60938 6.71094 8.60938C6.38733 8.60938 6.125 8.87171 6.125 9.19531C6.125 9.51892 6.38733 9.78125 6.71094 9.78125Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M4.16406 7.23438C4.48767 7.23438 4.75 6.97204 4.75 6.64844C4.75 6.32483 4.48767 6.0625 4.16406 6.0625C3.84046 6.0625 3.57812 6.32483 3.57812 6.64844C3.57812 6.97204 3.84046 7.23438 4.16406 7.23438Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M4.16406 9.78125C4.48767 9.78125 4.75 9.51892 4.75 9.19531C4.75 8.87171 4.48767 8.60938 4.16406 8.60938C3.84046 8.60938 3.57812 8.87171 3.57812 9.19531C3.57812 9.51892 3.84046 9.78125 4.16406 9.78125Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M4.16406 12.3359C4.48767 12.3359 4.75 12.0736 4.75 11.75C4.75 11.4264 4.48767 11.1641 4.16406 11.1641C3.84046 11.1641 3.57812 11.4264 3.57812 11.75C3.57812 12.0736 3.84046 12.3359 4.16406 12.3359Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M6.71094 12.3359C7.03454 12.3359 7.29688 12.0736 7.29688 11.75C7.29688 11.4264 7.03454 11.1641 6.71094 11.1641C6.38733 11.1641 6.125 11.4264 6.125 11.75C6.125 12.0736 6.38733 12.3359 6.71094 12.3359Z"
        fill={svgProps.fill || "#183E7A"}
      />
      <path
        d="M6.71094 7.23438C7.03454 7.23438 7.29688 6.97204 7.29688 6.64844C7.29688 6.32483 7.03454 6.0625 6.71094 6.0625C6.38733 6.0625 6.125 6.32483 6.125 6.64844C6.125 6.97204 6.38733 7.23438 6.71094 7.23438Z"
        fill={svgProps.fill || "#183E7A"}
      />
    </svg>
  );
}
